(function () {
  function mulberry32(seed) {
    return function () {
      seed |= 0;
      seed = (seed + 0x6d2b79f5) | 0;
      var t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function hashString(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
    }
    return hash;
  }

  function shuffleGrid() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    var items = grid.querySelectorAll(':scope > li.grid__item');
    if (items.length < 2) return;

    var seedKey = 'kk_shuffle_seed';
    var seed = window.sessionStorage.getItem(seedKey);
    if (!seed) {
      seed = String(Math.floor(Math.random() * 2147483647));
      window.sessionStorage.setItem(seedKey, seed);
    }

    var pageSeed = hashString(window.location.pathname + window.location.search) ^ parseInt(seed, 10);
    var random = mulberry32(pageSeed);

    var itemsArray = Array.prototype.slice.call(items);
    for (var i = itemsArray.length - 1; i > 0; i--) {
      var j = Math.floor(random() * (i + 1));
      var temp = itemsArray[i];
      itemsArray[i] = itemsArray[j];
      itemsArray[j] = temp;
    }

    var fragment = document.createDocumentFragment();
    itemsArray.forEach(function (item) {
      fragment.appendChild(item);
    });
    grid.appendChild(fragment);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', shuffleGrid);
  } else {
    shuffleGrid();
  }
})();
